import React from 'react';

import {
  ISearchMenuBarDropdown,
  SearchMenuBar,
} from '../../../components/organisms/SearchMenuBar';

const dropdownFilters: ISearchMenuBarDropdown[] = [
  {
    label: 'Email Authentication Checks',
    arrList: [
      {id: 0, content: 'DMARC'},
      {id: 1, content: 'SPF'},
      {id: 2, content: 'DKIM'},
      {id: 3, content: 'ARC'},
    ],
    type: 'emailChecks',
    width: 250,
  },
];

interface HeaderAnalysisListToolbarProps {
  selectedItems: any;
  resetFilter: () => void;
  handleEnterSearch: (event: any) => void;
  onFilter: (item: any, type: any) => void;
  searchInputValue: string;
  setSearchInputValue: React.Dispatch<React.SetStateAction<string>>;
  onClearFilter: (type: any) => void;
  filtersOpen: any;
  setFiltersOpen: (value: any) => void;
  handleKeywordFocus: (event?: React.FocusEvent<HTMLInputElement>) => void;
  searchFilterRef: React.MutableRefObject<any>;
}

export const HeaderAnalysisListToolbar: React.FC<HeaderAnalysisListToolbarProps> = ({
  selectedItems,
  resetFilter,
  handleEnterSearch,
  onFilter,
  searchInputValue,
  setSearchInputValue,
  onClearFilter,
  filtersOpen,
  setFiltersOpen,
  handleKeywordFocus,
  searchFilterRef,
}) => (
  <div id="search-menu-container">
    <SearchMenuBar
      selectedItems={selectedItems}
      resetFilter={resetFilter}
      handleEnterSearch={handleEnterSearch}
      onFilter={onFilter}
      searchInputValue={searchInputValue}
      setSearchInputValue={setSearchInputValue}
      onClearFilter={onClearFilter}
      dropdownFilters={dropdownFilters}
      filtersOpen={filtersOpen}
      setFiltersOpen={setFiltersOpen}
      handleKeywordFocus={handleKeywordFocus}
      searchFilterRef={searchFilterRef}
    />
  </div>
);
